import React, { Component } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import DialogContentText from '@material-ui/core/DialogContentText';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

class Table extends Component {
	onChange = e => {
		this.props.onChange('selectedTable', e.target.value);
	};

	render() {
		return (
			<div>
				{this.props.list.length ? (
					<div className="label-room-select">
						{!this.props.hideLabel ? (
							<DialogContentText>
								<Translate value={'binding.select_floor'} /> :
							</DialogContentText>
						) : null}

						<Select
							value={this.props.selected}
							onChange={this.onChange}
							displayEmpty
							onOpen={() =>
								this.props.removeListener ? this.props.removeListener() : null
							}
							onClose={
								this.props.addListener ? () => this.props.addListener() : null
							}>
							<MenuItem value="" disabled={!!this.props.required}>
								<i>{I18n.t('binding.none')}</i>
							</MenuItem>
							{this.props.list.map(p => (
								<MenuItem key={p.id} value={p.id}>
									{p.name}
								</MenuItem>
							))}
						</Select>
					</div>
				) : (
					<p className="paragraph-without-margin">
						<Translate value={'binding.empty_floor'} />
					</p>
				)}
			</div>
		);
	}
}

Table.defaultProps = {
	selected: '0',
	list: [],
};

Table.propTypes = {
	selected: PropTypes.string,
	list: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default Table;
